<template>
  <div class="d-modal-header-wrapper">
    <div v-if="!empty" class="d-modal-header">
      <slot></slot>
    </div>
    <div v-if="showClose" @click="handleCloseModal">
      <font-awesome-icon
        size="2x"
        class="d-modal-close"
        :icon="['fas', 'times']"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    empty: Boolean,
    closeModal: Function,
    showClose: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    function findModal(obj) {
      if (typeof obj.closeModal === "function") {
        return obj;
      } else {
        return findModal(obj.$parent);
      }
    }

    return {
      modal: findModal(this)
    };
  },
  methods: {
    handleCloseModal: function() {
      this.closeModal();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/login/modal/header.vue